"use strict";
exports.__esModule = true;
exports.DEFAULT_SRS = void 0;
exports.DEFAULT_SRS = {
    code: '4326',
    name: 'GCS WGS 1984',
    wkt: "\n    GEOGCS[\"WGS 84\",\n        DATUM[\"WGS_1984\",\n            SPHEROID[\"WGS 84\",6378137,298.257223563,\n                AUTHORITY[\"EPSG\",\"7030\"]],\n            AUTHORITY[\"EPSG\",\"6326\"]],\n        PRIMEM[\"Greenwich\",0,\n            AUTHORITY[\"EPSG\",\"8901\"]],\n        UNIT[\"degree\",0.01745329251994328,\n            AUTHORITY[\"EPSG\",\"9122\"]],\n        AUTHORITY[\"EPSG\",\"4326\"]]\n        "
};
//# sourceMappingURL=srs.js.map